/* =========================================================
   UNISOURCE COMMERCE PRIORITY v5
   Robust add-on script. Does not replace product/catalog JS.
========================================================= */

(function () {
  var GRID_SELECTORS = [
    '.poc-product-card',
    '.inksoft-product-card',
    '.inksoft-product-demo-card',
    '.poc-card',
    '.product-card',
    '[data-product-card]'
  ];

  function textOf(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function normalizedText(el) {
    return textOf(el).toLowerCase();
  }

  function isRfqElement(el) {
    var text = normalizedText(el);

    return (
      text === 'request a quote' ||
      text.indexOf('request a quote') !== -1 ||
      text.indexOf('request quote') !== -1
    );
  }

  function isDesignOnlineElement(el) {
    var text = normalizedText(el);

    return (
      text === 'design online' ||
      text.indexOf('design online') !== -1 ||
      text.indexOf('design now') !== -1 ||
      text.indexOf('see price') !== -1
    );
  }

  function closestProductGridCard(el) {
    if (!el || !el.closest) return null;

    for (var i = 0; i < GRID_SELECTORS.length; i += 1) {
      var card = el.closest(GRID_SELECTORS[i]);
      if (card) return card;
    }

    return null;
  }

  function getProductRoot() {
    return document.getElementById('inksoft-product-root');
  }

  function isInsideProductDetailPage(el) {
    var root = getProductRoot();
    return !!(root && el && root.contains(el));
  }

  function hideGridRfqButtons() {
    var candidates = document.querySelectorAll('a, button');

    Array.prototype.forEach.call(candidates, function (el) {
      if (!isRfqElement(el)) return;
      if (isInsideProductDetailPage(el)) return;

      var card = closestProductGridCard(el);
      if (!card) return;

      el.classList.add('unisource-commerce-rfq-hidden');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    });
  }

  function findProductButton(predicate) {
    var root = getProductRoot();
    if (!root) return null;

    var buttons = root.querySelectorAll('button, a');

    for (var i = 0; i < buttons.length; i += 1) {
      if (predicate(buttons[i])) return buttons[i];
    }

    return null;
  }

  function findCtaContainer(primaryBtn, secondaryBtn) {
    if (!primaryBtn) return null;

    var node = primaryBtn.parentElement;

    while (node && node !== document.body) {
      if (secondaryBtn && node.contains(secondaryBtn)) return node;
      if (node.className && String(node.className).indexOf('cta') !== -1) return node;
      if (node.className && String(node.className).indexOf('action') !== -1) return node;
      node = node.parentElement;
    }

    return primaryBtn.parentElement;
  }

  function updateProductDetailCtas() {
    var root = getProductRoot();
    if (!root) return;

    var designBtn =
      document.getElementById('inksoft-btn-design-online') ||
      findProductButton(isDesignOnlineElement);

    var quoteBtn =
      document.getElementById('inksoft-btn-request-quote') ||
      findProductButton(isRfqElement);

    if (designBtn) {
      designBtn.textContent = 'DESIGN NOW & SEE PRICE';
      designBtn.classList.add('unisource-commerce-primary-action');
      designBtn.setAttribute('aria-label', 'Design now and see price');
      designBtn.setAttribute('title', 'Customize your item and continue to see pricing.');
      designBtn.setAttribute('data-commerce-primary', 'true');
    }

    if (quoteBtn) {
      quoteBtn.textContent = 'ASK FOR HELP';
      quoteBtn.classList.add('unisource-commerce-secondary-action');
      quoteBtn.setAttribute('aria-label', 'Ask for help');
      quoteBtn.setAttribute('title', 'Use this for purchase orders, special requirements, or help from our team.');
      quoteBtn.setAttribute('data-commerce-secondary', 'true');
    }

    var ctaContainer = findCtaContainer(designBtn, quoteBtn);

    if (ctaContainer) {
      ctaContainer.classList.add('unisource-commerce-cta-container');

      if (!ctaContainer.querySelector('.unisource-design-online-helper')) {
        var helper = document.createElement('div');
        helper.className = 'unisource-design-online-helper';
        helper.innerHTML = '<strong>Start with Design Now.</strong> Customize your item and continue to see pricing. Use Ask for Help for purchase orders, special requirements, or assistance from our team.';
        ctaContainer.appendChild(helper);
      }
    }
  }

  function run() {
    hideGridRfqButtons();
    updateProductDetailCtas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('load', run);

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._unisourceCommerceTimer);
    observer._unisourceCommerceTimer = window.setTimeout(run, 80);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  console.info('[Unisource Commerce Priority] v5 loaded');
})();